import { isFunction } from "lodash";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useSortableBookmarkContext } from "../context/SortableBookmark";
import type { Bookmark } from "../helpers/bookmark_helper";

export interface ManageBookmarkActionsProps {
  bookmark: Bookmark;
  onDeleteClick?: (bookmark: Bookmark) => void;
  onEditClick?: (bookmark: Bookmark) => void;
}

export const ManageBookmarkActions = ({
  bookmark,
  onEditClick,
  onDeleteClick,
}: ManageBookmarkActionsProps) => {
  const { setIsFolderDropdownOpen } = useSortableBookmarkContext();

  return (
    <Dropdown
      direction="bottom-start"
      buttonClassName="flex w-5 h-5 hover:bg-black/10 rounded"
      transitionWrapperClassName="pt-2.5"
      button={<Icon type="menu-dots-v2" className="text-dark" size={16} />}
      onToggle={isOpen => setIsFolderDropdownOpen(isOpen)}
    >
      <Dropdown.ItemWithLink
        onClick={event => {
          event.preventDefault();
          isFunction(onEditClick) && onEditClick(bookmark);
        }}
      >
        {t("edit")}
      </Dropdown.ItemWithLink>
      <Dropdown.ItemWithLink
        onClick={event => {
          event.preventDefault();
          isFunction(onDeleteClick) && onDeleteClick(bookmark);
        }}
      >
        {t("delete")}
      </Dropdown.ItemWithLink>
    </Dropdown>
  );
};
